(function () {
  const selectors = {
    fruitNames: ".fruit-names-swiper",
  };

  const fruitNamesSwiper = document.querySelectorAll(selectors.fruitNames);

  if (fruitNamesSwiper.length == 0) return;

  fruitNamesSwiper.forEach((swiper) => {
    new Swiper(`[data-swiper-id="${swiper.dataset.swiperId}"]`, {
      slidesPerView: "auto",
      spaceBetween: 5,
    });
  });
})();

(function () {
  new Swiper(".announcement-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
})();

const iconWithTextSlider = () => {
  const selectors = {
    swiper: ".icon--with--text--slider",
  };

  const swiperElements = document.querySelectorAll(selectors.swiper);

  if (swiperElements.length == 0) return;

  swiperElements.forEach((swiper) => {
    const sectionId = swiper.dataset.sectionId;
    new Swiper(`${selectors.swiper}[data-section-id="${sectionId}"]`, {
      spaceBetween: 5,
      slidesPerView: 5,
      loop: true,
      breakpoints: {
        500: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    });
  });
};

// iconWithTextSlider();

const productSwiper = () => {
  const selectors = {
    swiper: ".product-swiper-index",
  };

  const swiperElements = document.querySelectorAll(selectors.swiper);

  if (swiperElements.length == 0) return;

  swiperElements.forEach((swiper) => {
    const sectionId = swiper.dataset.sectionId;
    const slidesPerView = parseInt(swiper.dataset.slidesPerView);

    new Swiper(`${selectors.swiper}[data-section-id="${sectionId}"]`, {
      slidesPerView: slidesPerView,
      spaceBetween: 30,
      // Navigation arrows
      navigation: {
        nextEl: `#shopify-section-${sectionId} .swiper-button-next`,
        prevEl: `#shopify-section-${sectionId} .swiper-button-prev`,
      },
      // If we need pagination
      pagination: {
        el: `#shopify-section-${sectionId} .swiper-pagination`,
      },
      breakpoints: {
        950: {
          slidesPerView: slidesPerView,
          spaceBetween: 30,
        },
        320: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
      },
    });
  });
};

(function () {
  const selectors = {
    fruitName: "fruits_names__name",
  };

  const fruitsNames = document.querySelectorAll(`.${selectors.fruitName}`);
  if (!fruitsNames) return;

  fruitsNames.forEach((fruitName) => {
    fruitName.addEventListener("click", (e) => {
      const fruitName = e.target.innerText.toLowerCase();
      const slide = document.querySelector(
        `.slider__slide[data-media-alt="${fruitName}"]`
      );
      const slideMediaId = slide.dataset.mediaId;

      document
        .querySelectorAll("media-gallery")
        .forEach((gallery) => gallery.setActiveMedia(slideMediaId, false));
    });
  });
})();

(function () {
  const selectors = {
    klaviyoFlyout: ".klaviyo-flyout",
    klaviyoFlyoutClose: ".klaviyo-close",
    klaviyoData: ".klaviyo-data",
  };

  const klaviyoFlyout = document.querySelector(selectors.klaviyoFlyout);
  const klaviyoData = document.querySelector(selectors.klaviyoData);

  const klaviyoFlyoutClose = document.querySelector(
    selectors.klaviyoFlyoutClose
  );

  if (klaviyoFlyout) {
    klaviyoFlyout.addEventListener("click", (e) =>
      e.target.closest(".klaviyo-close")
        ? closeKlaviyoFloyout()
        : openKlaviyoPopup()
    );

    klaviyoFlyoutClose.addEventListener("click", () => closeKlaviyoFloyout());

    // Debounced scroll event listener
    window.addEventListener("scroll", debounce(checkScrollPercentage, 200));
  }

  const klaviyoTriggers = document.querySelectorAll('a[href^="#klaviyo"]');
  klaviyoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => openKlaviyoPopup());
  });

  function openKlaviyoPopup() {
    const mobileForm = klaviyoData.dataset.mobileForm;
    const desktopForm = klaviyoData.dataset.desktopForm;
    window._klOnsite = window._klOnsite || [];
    let formToOpen = window.innerWidth < 768 ? mobileForm : desktopForm;
    window._klOnsite.push(["openForm", formToOpen]);
  }

  function closeKlaviyoFloyout() {
    klaviyoFlyout.style.display = "none";
  }

  // Function to check if the user has scrolled 50% of the webpage
  function checkScrollPercentage() {
    const scrollPercentage =
      (window.scrollY /
        (document.documentElement.scrollHeight - window.innerHeight)) *
      100;

    if (scrollPercentage >= 25) {
      klaviyoFlyout.style.display = "block";
    } else {
      klaviyoFlyout.style.display = "none";
    }
  }

  // Function to debounce a function call
  function debounce(func, delay) {
    let timeoutId;

    return function () {
      const context = this;
      const args = arguments;

      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  }
})();

(function () {
  const selectors = {
    swiper: ".wholesale-review-swiper",
  };

  const swiperElements = document.querySelectorAll(selectors.swiper);

  if (swiperElements.length == 0) return;

  swiperElements.forEach((swiper) => {
    const sectionId = swiper.dataset.sectionId;
    const slidesPerView = 1;

    new Swiper(`${selectors.swiper}[data-section-id="${sectionId}"]`, {
      slidesPerView: slidesPerView,
      autoHeight: true,
      spaceBetween: 30,
      autoplay: {
        delay: 6000,
      },
    });
  });
})();

// Mobile menu close button handler
document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.menu-drawer__close-main');
  if (closeButton) {
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');
      if (menuDrawerContainer) {
        const summary = menuDrawerContainer.querySelector('summary');
        if (summary) {
          summary.click();
        }
      }
    });
  }
});

const menuDrawerSwipers = () => {
  const selectors = {
    swiper: ".menu-drawer-swiper",
  };
  const swiperElements = document.querySelectorAll(selectors.swiper);

  if (swiperElements.length == 0) return;

  swiperElements.forEach((swiper) => {
    const sectionId = swiper.dataset.for;

    new Swiper(`${selectors.swiper}[data-for="${sectionId}"]`, {
      slidesPerView: 1.6,
      spaceBetween: 10,
      // And if we need scrollbar
      scrollbar: {
        el: `[data-for="${sectionId}"] .swiper-scrollbar`,
      },
    });
  });
};

menuDrawerSwipers();

(function () {
  // Simple function to remove .00 from all price elements - runs once efficiently
  function removeDecimalsFromPrices() {
    const priceElements = document.querySelectorAll('.price-item--regular');
    priceElements.forEach(priceElement => {
      if (priceElement.textContent && priceElement.textContent.includes('.00')) {
        priceElement.textContent = priceElement.textContent.replace('.00', '');
      }
    });
  }

  function formatMoney(cents, format = "${{amount_no_decimals}}") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  const selectors = {
    sellingPlan: ".product-form input[name='selling_plan']",
    priceInsideButton: "#price-inside-button",
    mainPrice: "[id^='price-template']",
    salePrice: ".price__sale .price-item.price-item--sale",
    regularPrice: ".price-item.price-item--regular",
    membershipCheckbox: '#membership-checkbox',
    memberPrice: '#membership-member-price'
  };

  let sellingPlan = document.querySelector(selectors.sellingPlan);

  const handleSellingPlanChange = (planValue) => {
    const priceInsideButton = document.querySelector(
      selectors.priceInsideButton
    );

    const mainPrice = document.querySelector(selectors.mainPrice);
    let priceContainer;
    if (mainPrice.querySelector(".price--on-sale")) {
      priceContainer = mainPrice.querySelector(selectors.salePrice);
    } else {
      priceContainer = mainPrice.querySelector(selectors.regularPrice);
    }

    let newPrice;

    const floatPrice = parseFloat(
      priceContainer.dataset.price.replace(/[^0-9.]/g, "")
    );
    if (planValue === "") {
      console.log("OTP selected");
      newPrice = floatPrice;
    } else {
      console.log("SUBSCRIPTION selected");
      newPrice = floatPrice - floatPrice * 0.1;
    }

    priceContainer.innerText = formatMoney(newPrice * 100);
    priceInsideButton.innerText = formatMoney(newPrice * 100);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    const sellingPlan = document.querySelector(selectors.sellingPlan);
    if (!sellingPlan) return;
    handleSellingPlanChange(sellingPlan.value);
  });

  let interval = setInterval(() => {
    sellingPlan = document.querySelector(selectors.sellingPlan);

    if (sellingPlan) {
      sellingPlan.addEventListener("change", function (e) {
        handleSellingPlanChange(e.target.value);
      });
      clearInterval(interval);
    }
  }, 1000);

  // Remove decimals from all prices efficiently
  document.addEventListener('DOMContentLoaded', function() {
    removeDecimalsFromPrices();
  });

  // Also handle variant changes efficiently
  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    // Small delay to ensure new prices are rendered
    setTimeout(removeDecimalsFromPrices, 50);
  });
})();

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  productSwiper();
  iconWithTextSlider();
});

// Handle Shopify section events without using closest()
document.addEventListener("shopify:section:load", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

document.addEventListener("shopify:section:select", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

document.addEventListener("shopify:section:deselect", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

document.addEventListener("shopify:section:reorder", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

document.addEventListener("shopify:block:select", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

document.addEventListener("shopify:block:deselect", () => {
  if (document.querySelector(".section-product-swiper-index")) productSwiper();
  if (document.querySelector(".section-icon-with-text-swiper")) iconWithTextSlider();
});

/// NEW JS (OLENA)

// Add membership price update functionality
(function() {
  const selectors = {
    membershipCheckbox: '#membership-checkbox',
    priceInsideButton: '#price-inside-button',
    priceInsideStickyButton: '#price-inside-button-sticky',
    regularPrice: '#membership-reg-price',
    memberPrice: '#membership-member-price'
  };

  document.addEventListener('DOMContentLoaded', function() {
    const membershipCheckbox = document.querySelector(selectors.membershipCheckbox);
    const priceInsideButton = document.querySelector(selectors.priceInsideButton);
    const priceInsideStickyButton = document.querySelector(selectors.priceInsideStickyButton);
    const regularPriceElement = document.querySelector(selectors.regularPrice);
    const memberPriceElement = document.querySelector(selectors.memberPrice);

    if (!membershipCheckbox || !priceInsideButton || !regularPriceElement || !memberPriceElement) return;

    membershipCheckbox.addEventListener('change', function() {
      // Mutual exclusion: uncheck subscription when membership is checked
      const subscriptionCheckbox = document.getElementById('subscription-checkbox');
      if (this.checked && subscriptionCheckbox && subscriptionCheckbox.checked) {
        subscriptionCheckbox.checked = false;
        // Close subscription accordion
        const subscriptionAccordion = document.getElementById('subscription-block');
        if (subscriptionAccordion) {
          subscriptionAccordion.classList.remove('is-open');
        }
      }
      
      const regularPrice = regularPriceElement.textContent;
      const memberPrice = memberPriceElement.textContent;
      
      // Check if subscription is also selected
      const hasSubscription = subscriptionCheckbox && subscriptionCheckbox.checked;
      
      let priceHtml;
      if (this.checked) {
        // Membership is selected - it takes precedence over subscription (15% > 10%)
        priceHtml = `<div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Member price</span><span class="price-item price-item--regular">${memberPrice}</span></div></div></div>`;
        console.log('Membership selected - showing member price (15% off)');
      } else {
        // Membership unchecked - check if subscription is still selected
        if (hasSubscription) {
          // Subscription is still selected, show subscription price
          const subscriptionPriceElement = document.getElementById('subscription-subscription-price');
          if (subscriptionPriceElement) {
            const subscriptionPrice = subscriptionPriceElement.textContent;
            priceHtml = `<div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Subscription price</span><span class="price-item price-item--regular">${subscriptionPrice}</span></div></div></div>`;
            console.log('Membership unchecked, subscription still selected - showing subscription price (10% off)');
          } else {
            priceHtml = `<div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">${regularPrice}</span></div></div></div>`;
            console.log('Membership unchecked, no subscription - showing regular price');
          }
        } else {
          // Neither selected, show regular price
          priceHtml = `<div class="price"><div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">${regularPrice}</span></div></div></div>`;
          console.log('Neither membership nor subscription selected - showing regular price');
        }
      }
      
      // Update both regular and sticky button prices
      priceInsideButton.innerHTML = priceHtml;
      if (priceInsideStickyButton) {
        priceInsideStickyButton.innerHTML = priceHtml;
      }
    });
  });
})();

// Add mutual exclusion for subscription checkbox
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const subscriptionCheckbox = document.getElementById('subscription-checkbox');
    
    if (subscriptionCheckbox) {
      subscriptionCheckbox.addEventListener('change', function() {
        // Mutual exclusion: uncheck membership when subscription is checked
        const membershipCheckbox = document.getElementById('membership-checkbox');
        if (this.checked && membershipCheckbox && membershipCheckbox.checked) {
          membershipCheckbox.checked = false;
          // Close membership accordion
          const membershipAccordion = document.getElementById('membership-block');
          if (membershipAccordion) {
            membershipAccordion.classList.remove('is-open');
          }
          // Trigger membership change event to update button price
          membershipCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
})();
